import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { CALENDLY_URL } from '../data/content';
type CtaButtonProps = {
  label?: string;
  variant?: 'primary' | 'ghost';
  className?: string;
};
export function CtaButton({
  label = 'Reservar auditoría de escala',
  variant = 'primary',
  className = ''
}: CtaButtonProps) {
  const base = 'group inline-flex items-center gap-2 whitespace-nowrap rounded-full px-6 py-3.5 text-sm font-medium transition-[background-color,color,border-color,transform] duration-150 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-ink-950';
  const styles = variant === 'primary' ? 'bg-accent-deep text-white hover:bg-[#D93325]' : 'border border-white/20 text-white hover:border-white/50 hover:bg-white/5';
  return <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" className={`${base} ${styles} ${className}`} data-id="element-35" data-mp="198yzbl6eix2i">
      {label}
      <ArrowUpRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5 group-hover:-translate-y-0.5" aria-hidden="true" data-id="element-36" data-mp="35y7jegm11101" />
    </a>;
}